import { useEffect, useState } from "react";

//api
import { ProjectManagementService } from "../../../service/projectmanagement-service";

//components
import { InputTextarea } from "primereact/inputtextarea";

const ElaborationProject = ({projectId, elaboration})=>{
    const [project,setProject] = useState(null);

    // GET per il dettaglio progetto
    useEffect(()=> {
        const fetchProject=()=>{
            if(projectId){
                ProjectManagementService.getProject(projectId,(data)=>{
                    setProject(data)
                },
                (error) => {
                    console.error("Errore durante il recupero del progetto:", error);
                    setProject(null);
                })  
            }      
        }
        fetchProject()
    },[projectId])

    return (
        <div style={{marginBottom:'2rem'}}>
            <div className="elaborationDetail__ProjectWrapper">
                <h3>Dettagli Progetto</h3>
                <div>
                    <p>Nome Progetto: {project?.name}</p>
                    <p>Descrizione: {project?.notes}</p>
                </div>
                <div>
                    <div className="elaborationDetail__PromptWrapper">
                        <label><strong>Prompt di Default</strong></label>
                        <InputTextarea
                            value={elaboration?.custom_user_prompt}
                            rows={5}
                            cols={20}
                        />
                    </div>
                    <div className="elaborationDetail__PromptWrapper">  
                        <label><strong>Prompt di Sistema</strong></label>
                        <InputTextarea
                            value={elaboration?.custom_system_prompt}
                            rows={5}
                            cols={20}
                        />
                    </div>
                </div>        
            </div>
        </div>         
    )
}

export default ElaborationProject